var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1TopDownArrowA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 41h16L38 57 22 41h16zm16-6L38 19 22 35h32z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Top-down_arrow_A.26887afb.svg";
export { SvgJ1TopDownArrowA as ReactComponent };